export const validateVipCodeInput = (input) => {
    // 保存当前光标位置
    const value = input.value;
    const cursorPosition = input.selectionStart;
    // 验证并替换非整数输入
    let newValue = value.replace(/[^0-9]/g, '');
    // 限制输入长度不超过四位
    if (newValue.length > 4) {
        newValue = newValue.slice(0, 4);
    }
    // 更新输入框的值
    input.value = newValue;
    // 恢复光标位置
    const newCursorPosition = Math.min(cursorPosition, newValue.length);
    input.setSelectionRange(newCursorPosition, newCursorPosition);
};
